export default __webpack_public_path__ + "static/media/user-active.2102711a.svg";